import { render, staticRenderFns } from "./DragTest.vue?vue&type=template&id=174ebeee&scoped=true&"
import script from "./DragTest.vue?vue&type=script&lang=js&"
export * from "./DragTest.vue?vue&type=script&lang=js&"
import style0 from "./DragTest.vue?vue&type=style&index=0&id=174ebeee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174ebeee",
  null
  
)

export default component.exports